<template>
    <div>
        <Support />
        <Footer />
    </div>
</template>


